export class DistributionArea{
    id!: string;
    name!: string;
}